import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Dropdown, Tooltip } from 'antd';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './aside-menu.scss';

// Config
import { CCounsellorPageMenuList } from '../../../../configs/components/counsellors.config';

type TAsideMenuProps = {
  pathState: {
    current: string;
    prev: string;
  },
  counsellorId: string | number,
}

export const AsideMenu: FC<TAsideMenuProps> = (
  { pathState: { current: currentPath }, counsellorId }: TAsideMenuProps
): JSX.Element => {

  const navigate = useNavigate();

  const getReplacedPath = (path: string): string => {
    return path.replace('{id}', `${ counsellorId }`);
  }

  const navigateToCounsellorSubPage = (path: string): void => {
    navigate(`/${ getReplacedPath(path) }`);
  }

  return (
    <div className="aside-menu">
      {
        CCounsellorPageMenuList.map(({ icon, path, activeIcon, label }) => {
          const isActive = currentPath === getReplacedPath(path);
          return (
            <Tooltip key={ Math.random() } placement={ 'right' } title={ label }>
              <div
                className={ `aside-menu--item ${ isActive ? ' active-item' : '' }` }
                onClick={ () => navigateToCounsellorSubPage(path) }>
                <span className="icon-item">{ isActive ? activeIcon : icon }</span>
                <span className="text-item">{ label }</span>
              </div>
            </Tooltip>
          )
        })
      }
      <div className="aside-menu--actions">
        <Dropdown menu={ {
          items: CCounsellorPageMenuList.map(({ icon, path, activeIcon, label }) => ({
            key: Math.random(),
            label: <Tooltip key={ Math.random() } placement={ 'right' } title={ label }>
              <div
                className={ `aside-menu--item ${ currentPath === getReplacedPath(path) ? ' active-item' : '' }` }
                onClick={ () => navigateToCounsellorSubPage(path) }>
                <span className="icon-item">{ currentPath === getReplacedPath(path) ? activeIcon : icon }</span>
                <span className="text-item">{ label }</span>
              </div>
            </Tooltip>
          }))
        } } trigger={ ['click'] } placement="bottomLeft" arrow>
          <CustomIcon name={ EIconName.BurgerMenu }/>
        </Dropdown>
      </div>
    </div>
  )
};
